"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFormField = exports.submitACHInfo = exports.openOrCloseModal = exports.mockFillForm = exports.makePageShowConfirmationPage = exports.getBankName = exports.addValidations = exports.UPDATE_MODAL_STATE = exports.UPDATE_FORM_READY_TO_SUBMIT = exports.UPDATE_FORM_FIELD = exports.SUBMIT_ACH_INFO = exports.MOCK_FORM = exports.GET_BANK_NAME = exports.ADD_VALIDATIONS = exports.ACH_SUBMIT_INPROGRESS = exports.ACHSubmitInProgress = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var UPDATE_MODAL_STATE = 'UPDATE_MODAL_STATE';
exports.UPDATE_MODAL_STATE = UPDATE_MODAL_STATE;
var UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
exports.UPDATE_FORM_FIELD = UPDATE_FORM_FIELD;
var GET_BANK_NAME = 'GET_BANK_NAME';
exports.GET_BANK_NAME = GET_BANK_NAME;
var UPDATE_FORM_READY_TO_SUBMIT = 'UPDATE_FORM_READY_TO_SUBMIT';
exports.UPDATE_FORM_READY_TO_SUBMIT = UPDATE_FORM_READY_TO_SUBMIT;
var SUBMIT_ACH_INFO = 'SUBMIT_ACH_INFO';
exports.SUBMIT_ACH_INFO = SUBMIT_ACH_INFO;
var ADD_VALIDATIONS = 'ADD_VALIDATIONS';
exports.ADD_VALIDATIONS = ADD_VALIDATIONS;
var ACH_SUBMIT_INPROGRESS = 'ACH_SUBMIT_INPROGRESS';
exports.ACH_SUBMIT_INPROGRESS = ACH_SUBMIT_INPROGRESS;
var MOCK_FORM = 'MOCK_FORM';
exports.MOCK_FORM = MOCK_FORM;
var http = require('lc-http');
var openOrCloseModal = function openOrCloseModal(flag) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", dispatch({
              type: UPDATE_MODAL_STATE,
              payload: {
                isOpen: flag
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
exports.openOrCloseModal = openOrCloseModal;
var makePageShowConfirmationPage = function makePageShowConfirmationPage(flag) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", dispatch({
              type: UPDATE_FORM_READY_TO_SUBMIT,
              payload: {
                showConfirmationPage: flag
              }
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.makePageShowConfirmationPage = makePageShowConfirmationPage;
var ACHSubmitInProgress = function ACHSubmitInProgress() {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", dispatch({
              type: ACH_SUBMIT_INPROGRESS,
              payload: {
                currentFocus: '',
                navigationToNextPage: 'pending'
              }
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
exports.ACHSubmitInProgress = ACHSubmitInProgress;
var submitACHInfo = function submitACHInfo() {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch, getState) {
      var _getState, siteInfo, form, postACHUrl;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _getState = getState(), siteInfo = _getState.siteInfo;
            form = _objectSpread({}, getState().form);
            postACHUrl = siteInfo.realm === 'LCYTS' || siteInfo.realm === 'LCK12' ? '/ach-enroll/submitACH' : '/patientsolutions/app/ach-enroll/submitACH';
            _context4.prev = 3;
            _context4.next = 6;
            return http.post(postACHUrl, {
              loanId: form.loanId,
              achFromBE: form.achFromBE,
              formData: form.formData,
              realm: siteInfo.realm
            });
          case 6:
            return _context4.abrupt("return", dispatch({
              type: SUBMIT_ACH_INFO,
              payload: {
                currentFocus: '',
                navigationToNextPage: 'true'
              }
            }));
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](3);
            return _context4.abrupt("return", dispatch({
              type: SUBMIT_ACH_INFO,
              payload: {
                currentFocus: '',
                navigationToNextPage: 'false'
              }
            }));
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 9]]);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
exports.submitACHInfo = submitACHInfo;
var addValidations = function addValidations(field, value) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch, getState) {
      var _getState2, form, errorFields;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _getState2 = getState(), form = _getState2.form;
            errorFields = (0, _toConsumableArray2.default)(form.errorFields);
            if (form.mandatoryFields.indexOf(field) > -1 && (field === 'fname' || field === 'lname') && !/^[a-zA-Z'\-. ]+$/.test(value)) {
              errorFields.indexOf(field) === -1 ? errorFields.push(field) : errorFields;
            } else if (form.mandatoryFields.indexOf(field) > -1 && field === 'rNumber' && value.length !== 9) {
              errorFields.indexOf(field) === -1 ? errorFields.push(field) : errorFields;
            } else if (form.mandatoryFields.indexOf(field) > -1 && (field === 'rNumber' || field === 'aNumber') && !/^[0-9]*$/.test(value)) {
              errorFields.indexOf(field) === -1 ? errorFields.push(field) : errorFields;
            } else if (form.mandatoryFields.indexOf(field) > -1 && field === 'rNumber' && value !== '' && form.formData.FIName === '') {
              errorFields.indexOf(field) === -1 ? errorFields.push(field) : errorFields;
            } else if (form.mandatoryFields.indexOf(field) > -1 && field === 'aNumber' && form.formData.caNumber !== '' && form.formData[field] !== form.formData.caNumber) {
              errorFields.indexOf(field) === -1 ? errorFields.push(field) : errorFields;
            } else if (form.mandatoryFields.indexOf(field) > -1 && field === 'caNumber' && form.formData.aNumber !== '' && form.formData[field] !== form.formData.aNumber) {
              errorFields.indexOf(field) === -1 ? errorFields.push(field) : errorFields;
            } else {
              errorFields = errorFields.reduce(function (acc, curr, ind, arr) {
                acc = curr !== field ? acc.concat([curr]) : acc;
                return acc;
              }, []);
            }
            return _context5.abrupt("return", dispatch({
              type: ADD_VALIDATIONS,
              payload: {
                errorFields: errorFields
              }
            }));
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
exports.addValidations = addValidations;
var getBankName = function getBankName(field, value) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch, getState) {
      var _getState3, siteInfo, _getState4, form, formData, errorFields, finErrIndex, routingURL, routingInfo;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _getState3 = getState(), siteInfo = _getState3.siteInfo;
            _getState4 = getState(), form = _getState4.form;
            formData = _objectSpread({}, form.formData);
            errorFields = (0, _toConsumableArray2.default)(form.errorFields);
            finErrIndex = errorFields.indexOf(field);
            routingURL = siteInfo.realm === 'LCYTS' || siteInfo.realm === 'LCK12' ? '/ach-enroll/routing' : '/patientsolutions/app/ach-enroll/routing';
            _context6.next = 8;
            return http.post(routingURL, {
              routingNumber: value
            });
          case 8:
            routingInfo = _context6.sent;
            formData[field] = value;
            formData.FIName = routingInfo.data.bankName === 'Not Found' ? '' : routingInfo.data.bankName;
            errorFields = formData.FIName !== '' && finErrIndex > -1 ? errorFields.filter(function (val) {
              return val !== field;
            }) : errorFields;
            return _context6.abrupt("return", dispatch({
              type: GET_BANK_NAME,
              payload: {
                errorFields: errorFields,
                formData: formData,
                currentFocus: field
              }
            }));
          case 13:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
exports.getBankName = getBankName;
var updateFormField = function updateFormField(field, value) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch, getState) {
      var _getState5, form, formData;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _getState5 = getState(), form = _getState5.form;
            formData = _objectSpread({}, form.formData);
            formData[field] = value;
            return _context7.abrupt("return", dispatch({
              type: UPDATE_FORM_FIELD,
              payload: {
                formData: formData,
                currentFocus: field
              }
            }));
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x10, _x11) {
      return _ref7.apply(this, arguments);
    };
  }();
};
exports.updateFormField = updateFormField;
var mockFillForm = function mockFillForm() {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch, getState) {
      var _getState6, form, formData;
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _getState6 = getState(), form = _getState6.form;
            formData = _objectSpread({}, form.formData);
            formData.rNumber = '061000052';
            formData.aNumber = '12343212';
            formData.FIName = 'BANK OF AMERICA, N.A.';
            formData.caNumber = '12343212';
            formData.fname = 'Approve';
            formData.lname = 'Bond';
            formData.aType = 'Checking';
            return _context8.abrupt("return", dispatch({
              type: MOCK_FORM,
              payload: {
                formData: formData
              }
            }));
          case 10:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x12, _x13) {
      return _ref8.apply(this, arguments);
    };
  }();
};
exports.mockFillForm = mockFillForm;
